/**
 * Création du store Redux
 */
import { configureStore } from "@reduxjs/toolkit";
import { createHashHistory } from "history";
import { combineReducers, compose } from "redux";
import { createReduxHistoryContext } from "redux-first-history";
import { reducer as adbReducer } from "./AdministrateurDeBien";
import { reducer as bienReducer } from "./Bien";
import { reducer as dossierLocationReducer } from "./DossierLocation";
import { reducer as nousContacterReducer } from "./NousContacterRedux";
import { reducer as partenaireReducer } from "./Partenaire";
import { reducer as piecesReducer } from "./Pieces";
import { reducer as situationPersonnelleReducer } from "./SituationPersonnelle";
import { reducer as situationProfessionnelleReducer } from "./SituationProfessionnelle";
import { reducer as typeVoieReducer } from "./TypeVoie";
import { reducer as utilisateursReducer } from "./Utilisateurs";
// import { reducer as formReducer } from "react-final-form";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";

// Création du root reducer

// export default function configureStore(initialState = {}, historique: History) {
//   // Création d'un middleware pour nos Sagas :
//   // On définit deux middlewares :
//   // 1. sagaMiddleware: pour faire fonctionner redux-saga
//   // 2. routerMiddleware: pour synchroniser URL paths avec le state
//   const { createReduxHistory, routerMiddleware, routerReducer } =
//     createReduxHistoryContext({
//       history: historique,
//       basename: "/app",
//       //other options if needed
//     });
//   const middlewares = [routerMiddleware(historique)];

//   const enhancers = [applyMiddleware(...middlewares)];

//   // Si l'extension Redux DevTools est installée on l'utilise
//   // Sinon on utilise le compose de Redux
//   const composeEnhancers =
//     process.env.NODE_ENV !== "production" &&
//     typeof window === "object" &&
//     window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
//       ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
//       : compose;

//   // Création du store
//   const store = createStore(
//     rootReducer,
//     initialState,
//     composeEnhancers(...enhancers)
//   ) as any;

//   // On ajoute une extension runSaga pour pouvoir démarrer le middleware saga après la création du store

//   // Hot reloading
//   if (module.hot) {
//     // Enable Webpack hot module replacement for reducers
//     module.hot.accept("./rootReducers", () => {
//       store.replaceReducer(rootReducer);
//     });
//   }

//   return store;
// }

const { routerMiddleware, createReduxHistory, routerReducer } =
  createReduxHistoryContext({
    history: createHashHistory(),
  });

// export default function configureStore({ pathname }: ConfigureStore = {}) {
//   const composeEnhancers =
//     process.env.NODE_ENV !== "production" &&
//     typeof window === "object" &&
//     window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
//       ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
//       : compose;
//   const composeMiddleware = (...middleware: Middleware[]) =>
//     process.env.NODE_ENV === "production"
//       ? applyMiddleware(...middleware)
//       : composeEnhancers(applyMiddleware(...middleware));
//   const createHistory = (pathname?: string) =>
//     createReduxHistoryContext({
//       history:
//         typeof window === "undefined" && pathname
//           ? createMemoryHistory({ initialEntries: [pathname] })
//           : createBrowserHistory(),
//     });

//   const { createReduxHistory, routerMiddleware, routerReducer } =
//     createHistory(pathname);

//   const store = createStore(
//     combineReducers({ ...rootReducer, router: routerReducer }),
//     composeMiddleware(routerMiddleware)
//   );

//   //   const store = createStore(
//   //     rootReducer,
//   //     initialState,
//   //     composeEnhancers(...enhancers)
//   //   ) as any;
//   const history = createReduxHistory(store);

//   // Hot reloading
//   // if (module.hot) {
//   //   // Enable Webpack hot module replacement for reducers
//   //   module.hot.accept("./rootReducers", () => {
//   //     store.replaceReducer(rootReducer);
//   //   });
//   // }
//   return { history, store };
// }

const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

// const persistedReducer = persistReducer(persistConfig, rootReducer);
const persistConfig = {
  key: "primary",
  storage: storageSession,
  blacklist: ["form", "router", "error"],
};

const rootReducer = combineReducers({
  adb: adbReducer,
  utilisateurs: utilisateursReducer,
  dossierLocation: dossierLocationReducer,
  bien: bienReducer,
  situationPersonnelle: situationPersonnelleReducer,
  situationProfessionnelle: situationProfessionnelleReducer,
  pieces: piecesReducer,
  typeVoie: typeVoieReducer,
  // form: formReducer,
  contact: nousContacterReducer,
  partenaire: partenaireReducer,
  router: routerReducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  // reducer: combineReducers({
  //   ...persistedReducer,
  //   router: routerReducer,
  //   composeEnhancers,
  // }),
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredPaths: ["pieces.archive"],
      },
      routerMiddleware,
    }),
});

export const history = createReduxHistory(store);
